export const getContactNamesFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
